import { http, url } from '@/api/warex/base';

export default {
  getAll () {
    return http.get(url(`/dyn-config/`));
  }
};